import script from "./DashboardToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardToolbar.vue?vue&type=script&setup=true&lang=js"

import "./DashboardToolbar.vue?vue&type=style&index=0&id=63965439&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63965439"]])

export default __exports__